module.exports = __webpack_public_path__ + "img/alfie-w4.f04a83a6.png";